import { TextProps } from '@features/powerpoint';

export const chartTitleText = (
  title: string,
  units: string,
  color: string
): TextProps['text'] => [
  {
    text: title.toUpperCase(),
    options: {
      color,
    },
  },
  {
    text: ` (${units.toUpperCase()})`,
  },
];
